import ValidationUtils from "../mixins/ValidationUtils";
import {AssertUtils} from "goingutils";


let _widthMapping = {
    xbig: 'input-xlarge',
    big: 'input-large',
    md: 'input-medium',
    small: 'input-small',
    sm: 'input-small'
};
export default {
    name: 'form-mixins',
    data() {
        let _inputItemJson = {};
        if (this.item != null) {
            for(let propName in this.$props){
                if(propName!=="item"){
                    this.setPropValue(this.item,propName,this.$props[propName]);
                }
            }
            //如果没有设置过hasError 则设置为false
            if(this.item["hasError"]==null){
                this.setPropValue(this.item,"hasError",false);
            }

            _inputItemJson = this.item;
        } else {
            for(let propName in this.$props){
                this.setPropValue(_inputItemJson,propName,this.$props[propName]);
            }
        }
        return {
            showValue: this.value || "",
            suffixIcon: "ivu-icon ivu-icon-ios-arrow-down",
            inputItem: _inputItemJson,
            clearIconRight:this.clearRight
        };
    },
    computed: {},
    props: {
        height:{type:String,default:'md'},
        //是否显示label的占位
        showLabelSlot:{},
        //校验内容
        validate: {
            type: [String,Object,Array],
            default: ''
        },
        //是否显示最大值
        showMaxLength: {
            type: Boolean,
            default: false
        },
        items:{},
        //清空值
        clearValue: {
            type: Boolean,
            default: true
        },
        clearRight:{},
        //是否存在右边区域内容的追加
        rightSlot: {
            type: Boolean,
            default: false
        },
        //控件类型
        ctlType: {
            type: String,
            default: ''
        },
        clearValueFun: {
            type: Boolean,
            default: false
        },
        domainData: {},
        //校验消息
        validMsg: {
            type: String,
            default: ""
        },
        //错误标示
        errorFlag: {},
        //是否显示radiobox
        radioBox: {
            type: Boolean,
            default: false
        },
        //radioBox的值
        radioVal: {
            type: [Boolean,String],
            default: false
        },
        readOnly: {},
        maxLength: {},
        suffixBtnColor: {},//后缀按钮的颜色
        suffixBtn: {},//后缀按钮
        suffixBtnIcon: {},//后缀按钮的图标
        suffixBtnLabel: {},//后缀按钮名称
        suffix: {},//后缀图标
        prefixBtnColor: {},
        prefixBtn: {},
        prefixBtnIcon: {},
        prefixBtnLabel: {},
        //前缀
        prefix: {},
        //是否可以点击
        disabled: {},
        //输入值
        value: {},
        item: {
            type: Object,
            default: () => {
                return null;
            }
        },
        //输入框 提醒内容
        placeholder: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        //label的宽度
        labelWidth: {
            type: [String, Number],
            default: 110
        },
        //输入框的宽度
        width: {
            type: [String, Number],
            default: ''
        },
        //label的对齐方式
        labelAlign: {
            type: String,
            default: 'right'
        },
        //后缀信息
        suffixTip: {
            type: Boolean,
            default: false
        },
        //是否为必填
        required: {},
        hasError: {},
    },
    methods: {
        //设置参数值
        setPropValue(itemObj, propName, propValue) {
            if(itemObj==null){
                return void(0);
            }
            //如果对象属性存在 而且对象属性的值跟传入的值不一样
            if (itemObj[propName] != null&&AssertUtils.isNotNull(propValue)&&itemObj[propName]!==propValue) {
                //如果是字符串  则不能为空
                if(typeof(propValue)==='string'&&propValue===""){
                    return void(0);
                }
                itemObj[propName] = propValue;
            } else if(itemObj[propName] == null){
                //如果对象属性不存在 则需要通过set来设置
                this.$set(itemObj, propName, propValue);
            }
        },
        //失去焦点进行值校验
        blurValid(itemValue){
            //如果是readOnly 则表示不可以编辑 则不需要进行失去焦点而进行数据校验
            if(this.readOnly!==true){
                ValidationUtils.validateItemByType(this.validate,this.inputItem, itemValue,this);
            }
        },
        //初始化数据
        initDataFun(){
            this.clearErrorState();
        },
        //进行值校验操作
        validateFun(){
            if ($(this.$el).css("display") === "none") {
                return false;
            }
            //如果已经存在了错误标志 则直接返回true
            if(this.inputItem.hasError){
                return true;
            }
            //如果是下拉
            if($(this.$el).closest(".go-common-drop-ctl").css("display") === "none"){
                return false;
            }
            //如果没有错误标志 则进行一次数据校验
            let {hasError}=ValidationUtils.validateItemByType(this.validate,this.inputItem, this.value,this,this.$options.name);
            return hasError;
        },
        //清空查询错误的功能
        clearErrorState(){
            this.setPropValue(this.inputItem, 'hasError', false);
            this.setPropValue(this.inputItem, 'validMsg', '');
        },
        //如果存在状态变更的 才需要设置状态属性
        addStateProp(propName,propValue){
            if (propValue!=null) {
                //如果对象没有设置过 则采用set行数进行设置 如果存在则直接赋值
                this.item[propName]==null?this.$set(this.item,propName,propValue):this.item[propName]=propValue;
            }
        },
        //获取输入最大值
        getMaxLength(item) {
            if (AssertUtils.isNotEmpty(item.maxLength) && item.maxLength > 0) {
                return item.maxLength;
            }
        },
        //清空当前输入
        clearInputValue() {
            //如果不可以编辑 则直接返回
            if (this.inputItem.disabled||this.disabled) {
                return void (0);
            }
            //如果是存在清空函数  则执行用户定义的 而不是执行系统默认的
            if (this.clearValueFun) {
                this.$emit('clearInputValue', '');
            } else {
                this.$emit('input', '');
            }
            return false;
        },
        //获取输入框的样式信息
        getInputWidStyle() {
            let widSty= this._getInputWidStyle(this.width);
            //如果存在图标后缀 则需要变更显示方式
            if(AssertUtils.isNotEmpty(this.suffix)&&this.suffixTip){
                widSty["width"]="calc(100% - "+this.inputItem.labelWidth +"px)";
                if(parseFloat(this.width)>0){
                    widSty['width'] = this.width + 'px';
                }
            }
            return widSty;
        },
        //获取输入框的宽度
        getInputWid() {
            let extendCls=[];
            let vueObj = this;
            if (AssertUtils.isNotNull((_widthMapping)[vueObj.width])) {
                extendCls.push((_widthMapping)[vueObj.width]);
            } else {
                //如果传入的是数字 则根据用户指定的宽度返回
                extendCls.push((AssertUtils.isNotEmpty(vueObj.width) && AssertUtils.isNumber(vueObj.width)) ? vueObj.width : 'w100b');
            }
            if(this.rightSlot){
                extendCls.push('rightSlot');
            }
            //有些不需要提示tip
            if(AssertUtils.isNotEmpty(this.suffix)&&this.suffixTip){
                extendCls.push('inputSuffix');
            }
            return extendCls;
        },
        //获取输入框的宽度信息 如果用户输入了数字 则返回数字宽度到style里面
        _getInputWidStyle(width) {
            let styleJson = {position: 'relative'};
            if (AssertUtils.isNumber(width)) {
                styleJson['width'] = width + 'px';
            }
            return styleJson;
        },
        //计算下拉所处y的位置
        getDropYPosition() {
            //如果label和内容是分行显示
            if (this.labelAlign === 'top') {
                return 65;
            } else {
                return 35;
            }
        },
        //计算下拉所处位置
        getDropXPosition(inputEl) {
            //如果label和内容是分行显示
            if (this.labelAlign === 'top') {
                return 6;
            } else {
                let labelEl = $(inputEl).closest('.go-common-drop-ctl').find('.go-label');
                return parseFloat(labelEl.width()) + 6;
            }
        }
    },
    mounted() {
    },
    components: {}
};



// WEBPACK FOOTER //
// ./goingsrc/mixins/formMixins.js